declare namespace $ {

	type $mol_button_minor__title_shm_service_task_menu_1 = $mol_type_enforce<
		ReturnType< $shm_service_task_menu['pin_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_service_task_menu_2 = $mol_type_enforce<
		ReturnType< $shm_service_task_menu['pin_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_service_task_menu_3 = $mol_type_enforce<
		ReturnType< $shm_service_task_menu['archive_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_service_task_menu_4 = $mol_type_enforce<
		ReturnType< $shm_service_task_menu['archive_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_service_task_menu extends $shm_remove_menu {
		pin_title( ): string
		pin_toggle( next?: any ): any
		archive_title( ): string
		archive_toggle( next?: any ): any
		pinned( next?: boolean ): boolean
		archived( next?: boolean ): boolean
		pin_enabled( ): boolean
		archive_enabled( ): boolean
		remove_confirm_title( ): string
		hint( ): string
		align( ): string
		Pin( ): $mol_button_minor
		Archive( ): $mol_button_minor
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map